module.exports = __webpack_public_path__ + "static/media/captain.50359194.JPG";